import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, Tag, TagService } from 'lib-trend-core';

@Component({
    selector: 'tag-edit-component',
    // templateUrl: './tag-edit.component.html',
    templateUrl: './tag-edit.v2.component.html',
    styleUrls: ['./tag-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagEditComponent extends AbstractComponent {

  tag: Tag;
  colorBg: string = '#A5A6F6';
  colorFont: string = '#000';

  keywords: string[] = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<TagEditComponent>,
    public tagService: TagService,
    @Inject(MAT_DIALOG_DATA) public data: Tag
  ) {
    super(injector);
    this.tag = {} as Tag;
    this.createForm();
  }


  ngOnInit() {
    this.isNew = !this.data;
    if (!this.isNew) {
      this.tag = { ...this.data };
      this.keywords = [...(this.tag.keyword || [])];
      this.colorBg = this.tag.bgColor || '#A5A6F6';
      this.colorFont = this.tag.fontColor || '#000000';
      this.formGroup.patchValue({
        title: this.tag.title,
        bgColor: this.colorBg,
        fontColor: this.colorFont
      });
    }
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      bgColor: [this.colorBg, Validators.required],
      fontColor: [this.colorFont, Validators.required],
      title: [null, Validators.required],
    });
    this.formGroup.valueChanges.subscribe(value => {
      Object.assign(this.tag, value);
    });
  }


  close(): void {
    this.dialogRef.close();
  }

  save() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup)
      return;
    }
    this.tag.bgColor = this.colorBg;
    this.tag.fontColor = this.colorFont;
    this.tag.keyword = this.keywords;

    if (this.isNew) {
      this.tagService.create(this.tag).subscribe({
        next: (value) => {
          this.dialogRef.close(value);
          this.alertService.success(this.t('tag.edit.savedSuccess'));
        },
        error: (err) => {
          this.alertService.error(err.error.message);
        },
        complete: () => {
        },
      });
    } else {
      this.tagService.update(this.tag._id, this.tag).subscribe({
        next: (value) => {
          this.dialogRef.close(value);
          this.alertService.success(this.t('tag.edit.savedSuccess'));
        },
        error: (err) => {
          this.alertService.error(err.error.message);
        },
        complete: () => {
        },
      });
    }
  }

  selectColor() {
    const bgColor = this.colorBg;
    this.formGroup.get('bgColor').setValue(bgColor);
    this.tag.bgColor = bgColor;
  }

  selectColorFont() {
    const fontColor = this.colorFont;
    this.formGroup.get('fontColor').setValue(fontColor);
    this.tag.fontColor = fontColor;
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.keywords.push(value);
    }
    event.chipInput!.clear();
  }

  remove(value: string): void {
    const index = this.keywords.indexOf(value);

    if (index >= 0) {
      this.keywords.splice(index, 1);

    }
  }
}
